const color = {
  black: '#111',
  white: '#fefefe',
  gray: '#87868c',
  blue: '#1e78a9',
  green: '#009f9d',
  red: '#f2724f',
}

const font = {
  globalFont: `'Microsoft JhengHei', 'Segoe UI', Helvetica, Arial, Helvetica, sans-serif;`,
}

const screen = {
  screenXs: '480px',
  screenSm: '576px',
  screenMd: '768px',
  screenLg: '992px',
  screenXl: '1200px',
}

export const DefaultTheme = {
  ...color,
  ...font,
  ...screen,
}
